/* eslint-disable react/prop-types */
/* eslint-disable @typescript-eslint/naming-convention */
import { faAws, faMicrosoft } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useMemo, useState } from "react";
import { useHistory } from "react-router-dom";
import { Data } from "../../../store/terminal/types";

import TableActions from "../../../common/table/TableActions";
import {
  MRT_ColumnDef,
  MRT_PaginationState,
  MRT_SortingState,
  MaterialReactTable,
} from "material-react-table";

export interface Props {
  terminal: Data[];
  terminalCount: number;
  pagination: MRT_PaginationState;
  setPagination: (values: MRT_PaginationState) => void;
  isStaged?: boolean;
}

interface RowData {
  id: string;
  terminalType?: string;
  poiid?: string;
  tid?: string;
  mid?: string;
  serNo?: string;
  selected: boolean;
}

export class TerminalTableParams {
  page = 0;
  pageSize = 10;
  pageCount = 0;
  orderBy = -1;
  orderDirection = "";
  searchText = "";
  searchField = "attributes.TID";
  totalCount = 1;
  cache?: string = 'ignore';
  type? = 'Terminal';
}

export const ColumnToRecordMapping = [
  "attributes.TID",
  "attributes.TerminalType",
  "attributes.POIID",
  "attributes.MID",
  "attributes.SerNo",
];



const mapDataToTable = (terminal: Data[]): RowData[] => {
  return terminal.map((data) => {
    return {
      id: data.id,
      terminalType: data.attributes.TerminalType,
      poiid: data.attributes.POIID,
      tid: data.attributes.TID,
      mid: data.attributes.MID,
      serNo: data.attributes.SerNo,
      selected: data.selected || false,
    };
  });
};

const AwsIcon = () => (
  <FontAwesomeIcon icon={faAws} color="#FF5500" size="2x" />
);
const MicrosoftIcon = () => (
  <FontAwesomeIcon icon={faMicrosoft} color="#0062ad" size="2x" />
);

export default function TerminalTable({
  terminal,
  terminalCount,
  pagination,
  setPagination,
  isStaged,
}: Props) {
  const history = useHistory();

  const [sorting, setSorting] = useState<MRT_SortingState>([]);

  const editAction = (rowData: RowData) => {
    history.push(`/terminal/edit/${rowData.id}`);
  }; 

  const viewAction = (rowData: RowData) => {
    history.push(`/terminal/view/${rowData.id}`);
  };

  const editStagedAction = (rowData: RowData) => {
    history.push(`/injected-terminal/edit/${rowData.id}`);
  }; 

  const viewStagedAction = (rowData: RowData) => {
    history.push(`/injected-terminal/view/${rowData.id}`);
  };

  const size = 10;
  const columns =useMemo<MRT_ColumnDef<RowData>[]>(
          () => [
            { header: "TID", accessorKey: "tid", size },
            { header: "MID", accessorKey: "mid", size },
            { header: "Serial No", accessorKey: "serNo", size: 20 },
            { header: "Terminal Type", accessorKey: "terminalType", size },
            { header: "POI Device ID", accessorKey: "poiid", size },
          ],[]);

  return (
    <MaterialReactTable
      columns={columns}
      data={mapDataToTable(terminal)}
      getRowId={(row) => row.id}
      initialState={{ showColumnFilters: false, density: "spacious" }}
      enableTopToolbar={false}
      enableColumnFilters={false}
      enableColumnActions={false}
      manualFiltering
      manualPagination
      onPaginationChange={setPagination}
      onSortingChange={setSorting}
      rowCount={terminalCount}
      muiTablePaginationProps={{
        rowsPerPageOptions: [5, 10, 20],
      }}
      state={{
        pagination,
        sorting,
      }}
      enableRowActions
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "",
          size: 200,
        },
      }}
      positionActionsColumn="last"
      renderRowActions={({ row }) => (
        <TableActions
          section="Terminal"
          onView={() => isStaged ? viewStagedAction(row.original) : viewAction(row.original)}
          onEdit={() => isStaged ? editStagedAction(row.original) : editAction(row.original)}
        />
      )}
    />
  );
}
